<template>
<div class="container">
  <!-- container -->
  <h1><small>パスワード変更</small></h1>
  <div class="section">
    <div class="alert alert-info" role="alert">
      8文字以上の英数字記号で、英文字と数字をそれぞれ1文字以上使って下さい。<br>英文字は、大文字・小文字は区別されます。<br>利用可能な記号はこちらになります。<br> !"#$%&@'()*+,-./_ <br>
    </div>
    <form class="mb-5" action="index.html" method="post">
      <div class="form-group p-3">
        <label for="password-input" class="col-form-label">新しいパスワード<span class="attention">※</span></label>
        <input type="password" class="form-control" id="password-input" v-model="pass" ref="pass">
        <p v-if="!!pass && !isValidPassword" class="error-msg" ref="invalidPass">8文字以上の英数字記号で、英文字と数字をそれぞれ1文字以上使ってください</p>
      </div>
      <div class="form-group p-3">
        <label for="re-password-input" class="col-form-label">同じ新しいパスワードを入力して下さい<span class="attention">※</span></label>
        <input type="password" class="form-control" id="re-password-input"
         v-model="reInputPass" ref="reInputPass">
        <p v-if="!isMatch" class="error-msg" ref="reInputPassError">一致していません</p>
      </div>

      <div class="btn-group" role="group" aria-label="group">
        <router-link to="/profile" class="btn btn-outline-info btn-lg">キャンセル</router-link>
        <a href="#" class="btn btn-primary btn-lg" :class="submitStyle" @click.prevent="submit" ref="submit">パスワード変更</a>
      </div>
    </form>
  </div>
  <p class="text-right mt-5">
    <router-link to="/mypage">マイページへのリンク</router-link>
  </p>
</div>
</template>

<script>
import api from 'api'
import auth from 'auth'
import modal from 'util/modal'
export default {
  data () {
    return {
      pass: '',
      reInputPass: '',
      isDisabled: false
    }
  },
  computed: {
    isValidPassword () {
      return this.pass.length >= 8 &&
        this.pass.match(/^(?=.*?\d)(?=.*?[a-zA-Z])[A-Za-z!-9@_]{8,}$/)
    },
    isMatch () {
      return this.pass === this.reInputPass
    },
    submitStyle () {
      return (this.isValidPassword && this.isMatch) && !this.isDisabled ? '' : 'disabled'
    }
  },
  methods: {
    submit () {
      if (!this.isMatch || !this.isValidPassword) { return }
      this.isDisabled = true
      api.changePassword(this, { password: this.pass }).then(_ => {
        if (!auth.isPasswordUpdated()) {
          auth.updatePassword()
          this.$router.push('/mypage')
        } else {
          this.$router.push('/profile')
        }
      }).catch(err => {
        if (err.status === 401) {
          modal.showLoginModal(this)
        } else {
          modal.showErrorModal(this, err)
        }
        this.isDisabled = false
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// EditPassword.vue?0c27a99d